(function () {
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initLoveBox(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var configEl = root.querySelector('[data-love-box-config]');
    if (!configEl) return;

    var config = JSON.parse(configEl.textContent);
    var minItems = config.minItems || 3;
    var maxItems = config.maxItems || 6;
    var discounts = config.discounts || {};
    var discountCodes = config.discountCodes || {};
    var giftMessageMax = config.giftMessageMax || 200;
    var shareText = config.shareText || "Here's the LOVE box I built for you!";
    var defaultOccasions = ['Birthday', 'Anniversary', 'Thank You', 'Festive', 'Just Because', 'Corporate'];
    var selected = [];
    var lastUnlockedTier = 0;
    var lastCount = 0;
    var drawerExpanded = false;
    var mobileDrawerMq = window.matchMedia('(max-width: 989px)');

    var els = {
      tabs: root.querySelectorAll('[data-love-tab]'),
      panels: root.querySelectorAll('[data-love-panel]'),
      cards: root.querySelectorAll('[data-love-card]'),
      count: root.querySelector('[data-love-count]'),
      dots: root.querySelectorAll('[data-love-dot]'),
      tiers: root.querySelectorAll('[data-love-tier]'),
      items: root.querySelector('[data-love-items]'),
      hint: root.querySelector('[data-love-hint]'),
      subtotal: root.querySelector('[data-love-subtotal]'),
      savings: root.querySelector('[data-love-savings]'),
      total: root.querySelector('[data-love-total]'),
      cta: root.querySelector('[data-love-cta]'),
      message: root.querySelector('[data-love-message]'),
      drawer: root.querySelector('[data-love-drawer]'),
      drawerToggle: root.querySelector('[data-love-drawer-toggle]'),
      drawerPanel: root.querySelector('[data-love-drawer-panel]'),
      drawerBackdrop: root.querySelector('[data-love-drawer-backdrop]'),
      barHint: root.querySelector('[data-love-bar-hint]'),
      countPanel: root.querySelector('[data-love-count-panel]'),
      unlockToast: root.querySelector('[data-love-unlock-toast]'),
      occasion: root.querySelector('[data-love-occasion]'),
      giftMessage: root.querySelector('[data-love-gift-message]'),
      charCount: root.querySelector('[data-love-char-count]'),
      shareBtn: root.querySelector('[data-love-share]'),
      sharedBanner: root.querySelector('[data-love-shared-banner]'),
      sharedDismiss: root.querySelector('[data-love-shared-dismiss]'),
    };

    function isMobileDrawer() {
      return mobileDrawerMq.matches;
    }

    function syncDrawerMode() {
      if (!isMobileDrawer()) {
        if (els.drawer) els.drawer.classList.remove('is-collapsed', 'is-expanded');
        if (els.drawerBackdrop) {
          els.drawerBackdrop.hidden = true;
          els.drawerBackdrop.setAttribute('aria-hidden', 'true');
        }
        if (els.drawerToggle) els.drawerToggle.setAttribute('aria-expanded', 'false');
        root.classList.remove('is-drawer-open');
        document.body.classList.remove('love-box-scroll-lock');
        drawerExpanded = false;
        return;
      }

      if (!drawerExpanded) {
        if (els.drawer) {
          els.drawer.classList.add('is-collapsed');
          els.drawer.classList.remove('is-expanded');
        }
        if (els.drawerBackdrop) {
          els.drawerBackdrop.hidden = true;
          els.drawerBackdrop.setAttribute('aria-hidden', 'true');
        }
        if (els.drawerToggle) els.drawerToggle.setAttribute('aria-expanded', 'false');
        root.classList.remove('is-drawer-open');
        document.body.classList.remove('love-box-scroll-lock');
      }
    }

    function setDrawerExpanded(expanded) {
      if (!isMobileDrawer()) {
        syncDrawerMode();
        return;
      }

      drawerExpanded = expanded;
      if (els.drawer) {
        els.drawer.classList.toggle('is-collapsed', !expanded);
        els.drawer.classList.toggle('is-expanded', expanded);
      }
      if (els.drawerToggle) {
        els.drawerToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
      if (els.drawerBackdrop) {
        els.drawerBackdrop.hidden = !expanded;
        els.drawerBackdrop.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      }
      root.classList.toggle('is-drawer-open', expanded);
      document.body.classList.toggle('love-box-scroll-lock', expanded);
    }

    function getDiscount(count) {
      var key = String(count);
      if (discounts[key] != null) return Number(discounts[key]);
      var best = 0;
      Object.keys(discounts).forEach(function (k) {
        if (Number(k) <= count && Number(discounts[k]) > best) best = Number(discounts[k]);
      });
      return best;
    }

    function getDiscountCode(count) {
      var key = String(count);
      if (discountCodes[key]) return discountCodes[key];
      var bestKey = null;
      Object.keys(discountCodes).forEach(function (k) {
        if (Number(k) <= count && discountCodes[k] && (!bestKey || Number(k) > Number(bestKey))) {
          bestKey = k;
        }
      });
      return bestKey ? discountCodes[bestKey] : null;
    }

    function getOccasion() {
      return els.occasion ? els.occasion.value.trim() : '';
    }

    function getGiftMessage() {
      return els.giftMessage ? els.giftMessage.value.trim() : '';
    }

    function buildOccasionSelect() {
      if (!els.occasion) return;

      var occasions = Array.isArray(config.occasions) && config.occasions.length
        ? config.occasions
        : defaultOccasions;
      var placeholder = config.occasionPlaceholder
        || els.occasion.getAttribute('data-love-occasion-placeholder')
        || 'Select occasion';
      var current = els.occasion.value;

      els.occasion.innerHTML = '';
      var emptyOpt = document.createElement('option');
      emptyOpt.value = '';
      emptyOpt.textContent = placeholder;
      els.occasion.appendChild(emptyOpt);

      occasions.forEach(function (label) {
        var clean = String(label || '').trim();
        if (!clean) return;
        var opt = document.createElement('option');
        opt.value = clean;
        opt.textContent = clean;
        els.occasion.appendChild(opt);
      });

      if (current && occasions.indexOf(current) !== -1) {
        els.occasion.value = current;
      }
    }

    function isSelected(variantId) {
      return selected.some(function (item) { return item.variantId === variantId; });
    }

    function subtotalCents() {
      return selected.reduce(function (sum, item) { return sum + item.price; }, 0);
    }

    function refreshCards() {
      els.cards = root.querySelectorAll('[data-love-card]');
    }

    function getHighestUnlockedTier(count) {
      var best = 0;
      els.tiers.forEach(function (tier) {
        var n = Number(tier.getAttribute('data-love-tier'));
        if (count >= n && n > best) best = n;
      });
      return best;
    }

    function bumpDrawer() {
      if (!els.drawer || prefersReducedMotion()) return;
      els.drawer.classList.remove('is-bump');
      void els.drawer.offsetWidth;
      els.drawer.classList.add('is-bump');
      window.setTimeout(function () { els.drawer.classList.remove('is-bump'); }, 450);
    }

    function popCard(card) {
      if (!card || prefersReducedMotion()) return;
      card.classList.remove('is-pop');
      void card.offsetWidth;
      card.classList.add('is-pop');
      window.setTimeout(function () { card.classList.remove('is-pop'); }, 400);
    }

    function celebrateTier(tierNum, pct) {
      if (!tierNum || prefersReducedMotion()) return;

      els.tiers.forEach(function (tier) {
        if (Number(tier.getAttribute('data-love-tier')) === tierNum) {
          tier.classList.remove('is-celebrating');
          void tier.offsetWidth;
          tier.classList.add('is-celebrating');
        }
      });

      if (els.unlockToast) {
        els.unlockToast.textContent = '🎉 ' + pct + '% bundle savings unlocked!';
        els.unlockToast.hidden = false;
        window.setTimeout(function () { els.unlockToast.hidden = true; }, 2800);
      }

      bumpDrawer();
    }

    function animateDot(index) {
      if (prefersReducedMotion()) return;
      var dot = els.dots[index];
      if (!dot) return;
      dot.classList.remove('is-new');
      void dot.offsetWidth;
      dot.classList.add('is-new');
    }

    function buildShareUrl() {
      var base = window.location.origin + window.location.pathname;
      var params = new URLSearchParams();
      params.set('v', selected.map(function (item) { return item.variantId; }).join(','));
      var occasion = getOccasion();
      if (occasion) params.set('occ', occasion);
      return base + '?' + params.toString();
    }

    function copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try {
          document.execCommand('copy') ? resolve() : reject();
        } catch (err) {
          reject(err);
        }
        document.body.removeChild(ta);
      });
    }

    function showShareFeedback(text, isError) {
      if (!els.message) return;
      els.message.className = 'love-box__message' + (isError ? ' is-error' : ' is-success');
      els.message.textContent = text;
      window.setTimeout(function () {
        if (els.message && els.message.textContent === text) {
          els.message.className = 'love-box__message';
          els.message.textContent = '';
        }
      }, 3200);
    }

    function shareBox() {
      if (!selected.length) return;
      var url = buildShareUrl();

      if (navigator.share) {
        navigator.share({ title: document.title, text: shareText, url: url }).catch(function () {
          copyToClipboard(url).then(function () {
            showShareFeedback('Link copied — share it with someone special!');
          }).catch(function () {
            showShareFeedback('Could not share. Copy the URL from your browser bar.', true);
          });
        });
        return;
      }

      copyToClipboard(url).then(function () {
        showShareFeedback('Link copied — share your LOVE box picks!');
      }).catch(function () {
        showShareFeedback('Could not copy link. Try again.', true);
      });
    }

    function loadSharedBox() {
      var params = new URLSearchParams(window.location.search);
      var raw = params.get('v');
      if (!raw) return false;

      refreshCards();
      var ids = raw.split(',').map(function (id) { return id.trim(); }).filter(Boolean);
      var loaded = 0;

      ids.forEach(function (id) {
        if (selected.length >= maxItems || isSelected(id)) return;
        var card = root.querySelector('[data-love-card][data-variant-id="' + id + '"]');
        if (!card || card.getAttribute('data-available') !== 'true') return;
        selected.push({
          variantId: id,
          productId: card.getAttribute('data-product-id'),
          title: card.getAttribute('data-title'),
          price: Number(card.getAttribute('data-price')),
          image: card.getAttribute('data-image'),
        });
        loaded += 1;
      });

      var occ = params.get('occ');
      if (occ && els.occasion) {
        var hasOption = Array.prototype.some.call(els.occasion.options, function (opt) {
          return opt.value === occ;
        });
        if (hasOption) els.occasion.value = occ;
      }

      if (loaded && els.sharedBanner) {
        els.sharedBanner.hidden = false;
      }

      return loaded > 0;
    }

    function buildLineProperties() {
      var props = {
        '_love_box': 'true',
        'LOVE Box': 'Build your LOVE box',
      };
      var occasion = getOccasion();
      var giftMessage = getGiftMessage();
      if (occasion) props['Occasion'] = occasion;
      if (giftMessage) props['Gift message'] = giftMessage;
      return props;
    }

    function buildCartAttributes() {
      var attrs = {};
      var occasion = getOccasion();
      var giftMessage = getGiftMessage();
      if (occasion) attrs['LOVE Box occasion'] = occasion;
      if (giftMessage) attrs['LOVE Box gift message'] = giftMessage;
      if (selected.length) {
        attrs['LOVE Box items'] = selected.map(function (item) { return item.title; }).join(' · ');
      }
      return attrs;
    }

    function updateCharCount() {
      if (!els.charCount || !els.giftMessage) return;
      var len = els.giftMessage.value.length;
      els.charCount.textContent = len + ' / ' + giftMessageMax;
    }

    function updateUI(options) {
      options = options || {};
      refreshCards();
      var count = selected.length;
      var sub = subtotalCents();
      var pct = count >= minItems ? getDiscount(count) : 0;
      var save = Math.round(sub * pct / 100);
      var total = sub - save;
      var unlockedTier = getHighestUnlockedTier(count);

      if (els.count) els.count.textContent = count + ' / ' + maxItems;
      if (els.countPanel) els.countPanel.textContent = count + ' / ' + maxItems;

      if (els.barHint) {
        if (count === 0) {
          els.barHint.textContent = 'Tap to build your box';
        } else if (count < minItems) {
          els.barHint.textContent = 'Add ' + (minItems - count) + ' more · tap to open';
        } else {
          els.barHint.textContent = count + ' items ready · tap to checkout';
        }
      }

      els.dots.forEach(function (dot, i) {
        var filled = i < count;
        dot.classList.toggle('is-filled', filled);
        if (options.animateAdd && filled && i === count - 1) animateDot(i);
      });

      els.tiers.forEach(function (tier) {
        var n = Number(tier.getAttribute('data-love-tier'));
        tier.classList.toggle('is-active', count >= n);
      });

      if (options.animateAdd && count > lastCount && count >= minItems && unlockedTier > lastUnlockedTier) {
        celebrateTier(unlockedTier, getDiscount(unlockedTier));
      }

      lastUnlockedTier = unlockedTier;
      lastCount = count;

      els.cards.forEach(function (card) {
        var variantId = card.getAttribute('data-variant-id');
        var available = card.getAttribute('data-available') === 'true';
        var btn = card.querySelector('[data-love-add]');
        var inBox = isSelected(variantId);
        var maxReached = count >= maxItems && !inBox;

        card.classList.toggle('is-selected', inBox);
        card.classList.toggle('is-disabled', !available || maxReached);

        if (btn) {
          btn.disabled = !available || maxReached;
          btn.classList.toggle('is-added', inBox);
          btn.textContent = inBox ? 'Added ✓' : (!available ? 'Out of stock' : 'Add to LOVE box');
        }
      });

      if (els.items) {
        if (!count) {
          els.items.innerHTML = '<p class="love-box__empty">Pick at least ' + minItems + ' favourites to build your box.</p>';
        } else {
          els.items.innerHTML = selected.map(function (item) {
            return (
              '<div class="love-box__item">' +
                '<img src="' + item.image + '" alt="" width="64" height="64" loading="lazy">' +
                '<div class="love-box__item-info">' +
                  '<p class="love-box__item-title">' + item.title + '</p>' +
                  '<div class="love-box__item-price">' + formatMoney(item.price) + '</div>' +
                '</div>' +
                '<button type="button" class="love-box__item-remove" data-remove-variant="' + item.variantId + '" aria-label="Remove">&times;</button>' +
              '</div>'
            );
          }).join('');
        }
      }

      if (els.hint) {
        if (count < minItems) {
          els.hint.innerHTML = 'Add <strong>' + (minItems - count) + ' more</strong> to unlock bundle savings.';
        } else if (count < maxItems) {
          var next = count + 1;
          var nextPct = getDiscount(next);
          if (nextPct > pct) {
            els.hint.innerHTML = 'Add <strong>1 more</strong> to unlock <strong>' + nextPct + '% off</strong>.';
          } else {
            els.hint.innerHTML = 'You unlocked <strong>' + pct + '% off</strong>. Add up to ' + (maxItems - count) + ' more.';
          }
        } else {
          els.hint.innerHTML = 'Maximum box size reached. <strong>' + pct + '% off</strong> applied.';
        }
      }

      if (els.subtotal) els.subtotal.textContent = formatMoney(sub);
      if (els.savings) els.savings.textContent = save > 0 ? '-' + formatMoney(save) : formatMoney(0);
      if (els.total) els.total.textContent = formatMoney(total);
      if (els.cta) {
        els.cta.disabled = count < minItems;
        els.cta.textContent = count < minItems
          ? 'Select ' + (minItems - count) + ' more item' + (minItems - count > 1 ? 's' : '')
          : 'Add LOVE Box to Cart';
      }
      if (els.shareBtn) els.shareBtn.disabled = count === 0;
    }

    function toggleItem(card) {
      var variantId = card.getAttribute('data-variant-id');
      if (!variantId || card.getAttribute('data-available') !== 'true') return;

      var adding = !isSelected(variantId);

      if (!adding) {
        selected = selected.filter(function (item) { return item.variantId !== variantId; });
        updateUI();
      } else {
        if (selected.length >= maxItems) return;
        selected.push({
          variantId: variantId,
          productId: card.getAttribute('data-product-id'),
          title: card.getAttribute('data-title'),
          price: Number(card.getAttribute('data-price')),
          image: card.getAttribute('data-image'),
        });
        updateUI({ animateAdd: true });
        popCard(card);
        bumpDrawer();
      }
    }

    els.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-love-tab');
        els.tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        els.panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-love-panel') === target);
        });
      }, { passive: true });
    });

    root.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-love-add]');
      if (addBtn) {
        e.preventDefault();
        toggleItem(addBtn.closest('[data-love-card]'));
        return;
      }
      var removeBtn = e.target.closest('[data-remove-variant]');
      if (removeBtn) {
        var id = removeBtn.getAttribute('data-remove-variant');
        selected = selected.filter(function (item) { return item.variantId !== id; });
        updateUI();
        return;
      }
      if (e.target.closest('[data-love-drawer-toggle]')) {
        e.preventDefault();
        setDrawerExpanded(!drawerExpanded);
        return;
      }
      if (e.target.closest('[data-love-drawer-backdrop]')) {
        e.preventDefault();
        setDrawerExpanded(false);
        return;
      }
      if (e.target.closest('[data-love-share]')) {
        e.preventDefault();
        shareBox();
        return;
      }
      if (e.target.closest('[data-love-shared-dismiss]')) {
        if (els.sharedBanner) els.sharedBanner.hidden = true;
      }
    });

    if (els.giftMessage) {
      els.giftMessage.addEventListener('input', updateCharCount, { passive: true });
      updateCharCount();
    }

    if (els.cta) {
      els.cta.addEventListener('click', function () {
        if (selected.length < minItems || els.cta.classList.contains('is-loading')) return;

        els.cta.classList.add('is-loading');
        if (els.message) {
          els.message.className = 'love-box__message';
          els.message.textContent = 'Adding to cart…';
        }

        var lineProps = buildLineProperties();
        var items = selected.map(function (item) {
          return {
            id: Number(item.variantId),
            quantity: 1,
            properties: lineProps,
          };
        });

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw result.data;

            var attrs = buildCartAttributes();
            var attrKeys = Object.keys(attrs);
            var afterAdd = attrKeys.length
              ? fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ attributes: attrs }),
                }).then(function (res) {
                  if (!res.ok) throw new Error('Cart attributes failed');
                  return res.json();
                })
              : Promise.resolve();

            return afterAdd.then(function () {
              var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
              var code = getDiscountCode(selected.length);
              if (els.message) {
                els.message.className = 'love-box__message is-success';
                els.message.textContent = code
                  ? 'LOVE box added! Applying ' + code + '…'
                  : 'LOVE box added! Redirecting to cart…';
              }
              if (code) {
                window.location.href =
                  '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
              } else {
                window.location.href = cartUrl;
              }
            });
          })
          .catch(function (err) {
            els.cta.classList.remove('is-loading');
            if (els.message) {
              els.message.className = 'love-box__message is-error';
              els.message.textContent = (err && err.description) || (err && err.message) || 'Could not add to cart. Please try again.';
            }
          });
      });
    }

    buildOccasionSelect();
    loadSharedBox();
    syncDrawerMode();
    mobileDrawerMq.addEventListener('change', syncDrawerMode);
    lastCount = selected.length;
    lastUnlockedTier = getHighestUnlockedTier(selected.length);
    updateUI();
  }

  function boot() {
    document.querySelectorAll('[data-love-box-root]').forEach(initLoveBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-love-box-root]');
    if (root) {
      delete root.dataset.initialized;
      initLoveBox(root);
    }
  });
})();
